import React from 'react';
import { Link } from "react-router-dom";
import favicon from './favicon.png';

const Navbar = () => {
    return (
        <>
            <header>
                <h2 title="Browse Beautiful Free Images & Pictures">
                    <Link to="/">
                        <img src={favicon} height="30px" width="30px" style={{ borderRadius: "3px" }} />
                    </Link>
                </h2>
                <ul>
                    <li title="Search">
                        <Link to="/search">Search</Link>
                    </li>
                    <li title="Reviews">
                        <Link to="/reviews">Reviews</Link>
                    </li>
                </ul>
            </header>
        </>
    )
}

export default Navbar;